module.exports = __webpack_public_path__ + "static/biko-ube-dd421b276ab4e89f6e307b56c73cb718.jpg";